import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, FormGroup } from '@angular/forms';

import { MustMatch } from './must-match.validator';

@Directive({
    selector: '[mustMatch2]',
    standalone: true,
    providers: [{ provide: NG_VALIDATORS, useExisting: MustMatch2Directive, multi: true }]
})
export class MustMatch2Directive implements Validator {
    @Input('mustMatch2') mustMatch: string[] = [];

    validate(formGroup: FormGroup): ValidationErrors {
      return MustMatch(this.mustMatch[0], this.mustMatch[1], this.mustMatch[2] )(formGroup);
    }
}
